import axiosClient from '../axiosClient';

export const getProducts = (params) =>
  axiosClient.get('/admin/shop/products', { params });

export const getProductDetail = (id) =>
  axiosClient.get(`/admin/shop/products/${id}`);

export const createProduct = (data) =>
  axiosClient.post('/admin/shop/products', data);

export const updateProduct = (id, data) =>
  axiosClient.put(`/admin/shop/products/${id}`, data);

export const deleteProduct = (id) =>
  axiosClient.delete(`/admin/shop/products/${id}`);

export const getOrders = (params) =>
  axiosClient.get('/admin/shop/orders', { params });

export const getOrderDetail = (id) =>
  axiosClient.get(`/admin/shop/orders/${id}`);

export const updateOrderStatus = (id, status, trackingNumber) =>
  axiosClient.patch(`/admin/shop/orders/${id}/status`, { status, trackingNumber });
